import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment-duration-format'

const TimeDuration = ({ duration, format }) =>
  moment.duration(duration, 'seconds').format(format, {
    trim: false
  })

TimeDuration.propTypes = {
  duration: PropTypes.number.isRequired,
  format: PropTypes.string.isRequired
}

export default TimeDuration
